<template>
  <section class="index-main-holder">
    <div
      class="e-sidebar-overlay"
      :class="{ 'overlay-open': sideBarOpen, 'overlay-closed': !sideBarOpen }"
      @click="hideSideBar"
    ></div>
    <loading
      :active="isLoaderActive"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <!-- Contenedor Principal de la página -->
    <div
      id="IndexMain"
      v-on:click="closeMenus"
      :style="{ marginLeft: marginSize }"
    >
      <!-- Wrapper de Pagina -->
      <div id="app-wrapper">
        <!-- v Contenedor Principal -->
        <div class="main-container">
          <!-- Componente de navegación vertical -->

          <MainNavComponent
            :navBackground="appBg"
            ref="mainNav"
            v-on:toggler-clicked="toggleSideBar"
          />
          <!-- ^ Holder (Wrapper de Notificaciones) -->

          <!-- Componente de notificación Toaster -->
          <!-- 

          <div class="e-sample-resize-container">
            <ejs-toast
              ref="toastRef"
              id="toast_type"
              :position="position"
              timeOut="3000"
              showCloseButton="true"
              showProgressBar="true"
            >
            </ejs-toast>

          </div>
          -->
          <!-- ^ Componente de notificación Toaster -->

          <!-- Componente de navegación Vertical (SidebarMenu) -->
          <papirus-side-bar ref="sideBar" />
          <!-- ^Componente de navegación Vertical (SidebarMenu) -->

          <!-- Contenedor Principal de Contenido -->
          <div id="app-body" class="content">
            <router-view :key="indexPageKey" />
          </div>
          <span v-show="false">{{ isExpired }}</span>
          <!-- ^ Contenedor Principal de Contenido -->
        </div>
        <!-- ^ Contenedor Principal -->
      </div>
      <!-- ^ Wrapper de Pagina -->
    </div>
    <!-- ^ Contenedor Principal de la página -->
  </section>
</template>

<script>
import Vue from "vue";
import MainNavComponent from "../../components/NavComponent/NavComponent.vue";
import PapirusSideBar from "../../components/PapirusSideBar/PapirusSideBar.vue";
import ToastMixin from "../../mixins/ToastMixin";
import LoaderMixin from "../../mixins/SpinnerMixin";
import SessionMixin from "../../mixins/SessionMixin";

/* https://www.npmjs.com/package/vue-loading-overlay */
import { ToastPlugin } from "@syncfusion/ej2-vue-notifications";
import Loading from "vue-loading-overlay";

import * as signalR from "@microsoft/signalr";

let gradient =
"linear-gradient(90deg, rgba(52,124,172) 0%, rgba(0, 0, 0, 1) 35%, rgba(52, 124, 172, 1) 100%)";;
Vue.use(ToastPlugin);
Vue.use(Loading);

Vue.mixin(LoaderMixin);

export default {
  components: { MainNavComponent, PapirusSideBar, Loading },
  mixins: [SessionMixin, ToastMixin],
  /* mixins: { LoaderMixin }, */
  computed: {
    sideBarOpen() {
      return this.$store.getters.drawerVisible;
    },
    indexPageKey() {
      return "index-" + this.$route.fullPath;
    },
    isExpired() {
      var expired = this.$store.getters.tokenExpired;
      return expired;
    }
  },
  watch: {
    isExpired(newVal, oldVal) {
      if (newVal != oldVal && newVal == true) {
        this.notifyLogout();
      }
    }
  },
  beforeCreate() {},
  created() {
    var instance = this;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(this.$AuthEndpoint + "/hubs/login-hub", {
        accessTokenFactory: () => localStorage.getItem("tkn")
      })
      .configureLogging(signalR.LogLevel.Error)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
          if (retryContext.elapsedMilliseconds < 150000) {
            // If we've been reconnecting for less than 60 seconds so far,
            // wait between 0 and 10 seconds before the next reconnect attempt.
            return 30000;
          } else {
            // If we've been reconnecting for more than 60 seconds so far, stop reconnecting.
            return null;
          }
        }
      })
      .build();

    //.withAutomaticReconnect([0, 5000, 10000, 30000])

    this.connection.on(
      "LoginCompletedMessage",
      this.loginCompletedMessageHandler
    );

    this.connection.on(
      "LogoutCompletedMessage",
      this.logoutCompletedMessageHandler
    );

    /*
    this.connection.on("LoginCompletedMessage", function {
      //   var msg = message
      //     .replace(/&/g, "&amp;")
      //     .replace(/</g, "&lt;")
      //     .replace(/>/g, "&gt;");
      //   var encodedMsg = user + " says " + msg;
      //   var li = document.createElement("li");
      //   li.textContent = encodedMsg;
      //   document.getElementById("messagesList").appendChild(li);
      console.log(user, message);
    });
*/
    this.connection.onreconnecting(this.onReconnecting);
    this.connection.onreconnected(this.onReConnected);
    this.connection.onclose(this.onDisconnect);

    this.connection
      .start()
      .then(function () {
        //console.log("Conexion iniciada");
        instance.signalMessage = "Conexion iniciada";
      })
      .catch(function (err) {
        instance.signalMessage = err.toString();
        //return console.error(err.toString());
      });
  },
  unmounted() {
    this.connection.stop();
  },
  updated() {},

  async mounted() {
    var active = this.isTokenActive();
    if (!active) this.$router.push("/logout");

    /*
    try {
      await this.$store.dispatch("minosParameters/getDataMaps");
      await this.$store.dispatch(
        "minosParameters/getParameterValues",
        "COMPLEXITY"
      );
      await this.$store.dispatch(
        "minosParameters/getParameterCode",
        "COMPLEXITY"
      );
      await this.$store.dispatch("minosParameters/getParameterValue", {
        code: "COMPLEXITY",
        subcode: "Baja"
      });
      console.log(
        JSON.stringify(this.$store.getters["minosParameters/parameterCodes"])
      );
      console.log(
        JSON.stringify(this.$store.getters["minosParameters/parameterValues"])
      );
      console.log(
        JSON.stringify(this.$store.getters["minosParameters/currentCode"])
      );
      console.log(
        JSON.stringify(this.$store.getters["minosParameters/currentValue"])
      );
    } catch (error) {
      console.log(error);
    }
    */
  },
  data() {
    return {
      connection: null,
      isReconnecting: false,
      marginSize: "0",
      appBg: gradient,
      isDevice: true,
      signalMessage: "",
      //sideBarOpen: false,
      position: {
        /*Determina la posición del Toaster*/
        X: "Right"
      }
    };
  },
  methods: {
    async loginCompletedMessageHandler(user, message) {
      var uid = this.$store.getters.userData.nameidentifier;

      if (uid == user) {
        this.signalMessage = message;
        //TODO: Validar el tema del Token, ya no usaremos la validacion entre sitios, debe ser un token Shortlived y lña validacion probablemente será directo con MCAS (Dapper).
        await this.$store.dispatch("checkTokenValidty");
      }
    },
    logoutCompletedMessageHandler(user, message) {
      var uid = this.$store.getters.userData.nameidentifier;

      if (uid == user) {
        this.signalMessage = message;
        this.$store.dispatch("logoutActionHandler");
      }
    },
    onDisconnect() {
      var instance = this;
      if (!instance.isReconnecting) {
        if (instance.connection == undefined) return;
        setTimeout(function () {
          instance.connection
            .start()
            .then(function () {
              //console.log("Conexion iniciada");
              instance.signalMessage = "Conexion Iniciada";
            })
            .catch(function (err) {
              //return console.error(err.toString());
              instance.signalMessage = err.toString();
            });
        }, 5000); // Restart connection after 5 seconds.
      }
    },
    onReconnecting() {
      this.isReconnecting = true;
    },
    onReConnected() {
      this.isReconnecting = false;
    },
    notifyLogout() {
      var expired = this.isExpired;

      if (expired) {
        this.showToast(
          "Se cerrará la Sesión",
          "Se ha iniciado sesión desde otra ubicación, o su sesión ha expirado.<br/> cerraremos la sesión actual.",
          3000
        );

        setTimeout(() => {
          this.$store.dispatch("logoutActionHandler");
        }, 5000);
      }
    },
    closeMenus() {
      if (this.$refs.mainNav.ShouldClose) this.$refs.mainNav.closeMenus();
    },
    openClick() {
      console.log("openClick Called");
    },
    toggleSideBar() {
      this.$refs.sideBar.toggleClick();
    },
    hideSideBar() {
      this.$store.commit("toggleDrawerVisibility", "close");
    }
  }
};
</script>

<style>
.not-allowed {
  cursor: not-allowed !important;
}

div#notifyPopup {
  z-index: 1009 !important;
  /* margin-top: 60px; */
}
.custom-toast {
  z-index: 1010 !important;
  position: fixed;
}

/* @import "../../../node_modules/@syncfusion/ej2-bootstrap-theme/styles/bootstrap4.css";*/
/* @import "../../../node_modules/@syncfusion/ej2-icons/styles/bootstrap4.css";*/
</style>

<style scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-icons/styles/bootstrap4.css";
@import "./index.css";
/* @import "../../../node_modules/@syncfusion/ej2-popups/styles/material.css"; */
</style>
